import React from 'react';
import { motion } from 'framer-motion';

const Header = () => {
  return (
    <motion.header 
      initial={{ y: 0, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="sticky top-0 z-50 bg-white shadow-sm border-b border-slate-100"
    >
      <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
     <div className="flex items-center gap-3">
    <img 
      src="https://firebasestorage.googleapis.com/v0/b/peyen-de088.firebasestorage.app/o/Logoblanco%20maac%20transparente.png?alt=media&token=2cdb1f5d-8283-4d55-bf8c-ad109bad9940" 
      alt="Logo" 
      className="h-10 w-auto" // Eliminamos 'invert' para mantener el color original
    />
  </div>

        {/* Enlaces de Navegación (Ejemplo) */}
     <div className="hidden md:flex items-center gap-8">
    <a href="#servicios" className="text-slate-600 hover:text-blue-600 font-medium transition-all">Servicios</a>
    <a href="#galeria" className="text-slate-600 hover:text-blue-600 font-medium transition-all">Galería</a>
    <a href="#contacto" className="text-slate-600 hover:text-blue-600 font-medium transition-all">Contacto</a>
  </div>
      </nav>
    </motion.header>
  );
};

export default Header;